import { Alert, Center } from "@mantine/core";
import MegaLoader from "../../Components/MegaLoader";
import { HttpSuccessCodesObj } from "../../Lib/data";
import { Endpoints } from "../../Lib/endpoints";
import { NonPaginatedResponse } from "../../Lib/responses";
import { ValidatePaystackTransactionResponseProps } from "../../Lib/types";
import { usePerformRequest } from "../../Lib/usePerformRequest";

//@ts-ignore
import { useParams } from 'react-router-dom'
import { IconCircleCheck } from "@tabler/icons-react";
import { useEffect } from "react";
export default function ValidatePaystackPayment(){
    const {reference} = useParams()
    const {data, isLoading, response} = usePerformRequest<NonPaginatedResponse<ValidatePaystackTransactionResponseProps>>({
      route: Endpoints.GetValidatePaystackPayment(reference ?? "").route,
      method: Endpoints.GetValidatePaystackPayment(reference ?? "").method
      
    });

    useEffect(() => {
        if(response && response.status === HttpSuccessCodesObj.Success){
            setTimeout(() => {
                window.location.href = "/d/courses"
            }, 2000)
        }
    }, [response])
    
    return (
        <div>
            <br/>
            <br/>
            {isLoading ? (
                <MegaLoader />
            ) : (
                <>
                <Center>
                    {response && response.status === HttpSuccessCodesObj.Success && (
                        <Alert variant="light" color="teal" title="Payment Success" icon={<IconCircleCheck />}>
                            Your payment was successful!
                            <br/>
                            This page will reload...
                        </Alert>
                    )}
                </Center>
                </>
            )}
        </div>
    )
}